<template>
    <el-table :data="agents" border>
        <el-table-column align="center" label="代理商名称" prop="agentName" />
        <el-table-column align="center" label="账号" prop="mobile" />
        <el-table-column align="center" label="地址">
            <template slot-scope="scope">
                {{
                scope.row.location || '--'
                }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="状态" prop="enable">
            <template slot-scope="scope">
                {{
                ENABLE[scope.row.enable]
                }}
            </template>
        </el-table-column>
        <el-table-column align="center" label="已授权通道总数" prop="channel">
            <template slot-scope="scope">
                <span>{{ scope.row.totalChannel }}</span>
                <el-button size="mini" type="text" @click="clickAuthDetail(scope.row)">授权明细</el-button>
            </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="action" width="280">
            <template slot-scope="scope">
                <el-button @click="clickEdit(scope.row)" size="mini">编辑</el-button>
                <el-button
                    @click="clickEnable(scope.row)"
                    size="mini"
                    type="danger"
                >{{ enableMap[scope.row.enable] }}</el-button>
                <router-link
                    :to="{
                        path: ROUTER_AGENT_DEVICE,
                        query: {
                            agentId: scope.row.agentId,
                            agentName: scope.row.agentName,
                        },
                    }"
                    style="margin-left: 10px;"
                    target="_blank"
                >
                    <el-button size="mini">设备管理</el-button>
                </router-link>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ROUTER_AGENT_DEVICE } from '../../router.js';
import {
    DIALOG_EDIT,
    ENABLE,
    ENABLE_TRUE,
    ENABLE_FALSE,
} from '../../libs/enum.js';

const { mapState, mapActions } = createNamespacedHelpers('agent');

export default {
    data() {
        return {
            ROUTER_AGENT_DEVICE,
            ENABLE,
            enableMap: {
                [ENABLE_TRUE]: '启用',
                [ENABLE_FALSE]: '禁用',
            },
        };
    },
    computed: {
        ...mapState({
            agents: state => state.agents,
        }),
    },
    methods: {
        ...mapActions([
            'changeDialog',
            'changeForm',
            'enableAgent',
            'changeAuthDetailDialog',
            'getAuthDetail',
        ]),
        clickEdit(data) {
            const location = data.location ? data.location.split(',') : '';
            const agent = {
                agentId: data.agentId,
                name: data.agentName,
                mobile: data.mobile,
                city: location.slice(0, 3),
                address: location.slice(-1)[0],
            };
            this.changeForm(agent);
            this.changeDialog({ type: DIALOG_EDIT, visible: true });
        },
        clickEnable({ agentId, enable }) {
            const text = this.enableMap[enable];
            this.$confirm(`是否要${text}账号？`, '提示', {
                type: 'warning',
            })
                .then(async () => {
                    await this.enableAgent({ agentId, enable: enable ? 0 : 1 });
                    this.$message.success(`${text}成功！`);
                })
                .catch(() => {
                    this.$message.info(`取消${text}`);
                });
        },
        clickAuthDetail({ agentId }) {
            this.getAuthDetail({ agentId });
            this.changeAuthDetailDialog({ visible: true });
        },
    },
};
</script>

<style></style>
